//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import UnidadeMedidaForm from './UnidadeMedidaForm';
import UnidadeMedidaLista from './UnidadeMedidaLista';

export default {
  name: 'UnidadeMedidaCadastro',
  data() {
    return {
    };
  },
  components: {
    UnidadeMedidaForm,
    UnidadeMedidaLista,
  },
  computed: {
    ...generateComputed('unid medida', [
      'canAccessCRUD',
      'canAccessPage',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    },
    onEditarUnidade(unidade) {
      this.$refs.unidadeMedidaForm.editar(unidade);
    },
    onUnidadeSalva() {
      this.$refs.unidadeTabela.filtrar();
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/unidade-medida/UnidadeMedidaCadastro.vue?vue&type=script&lang=js&